"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.printVersion = exports.cliVersion = void 0;
const chalk_1 = __importDefault(require("chalk"));
const package_json_1 = require("@datadog/datadog-ci-base/package.json");
exports.cliVersion = package_json_1.version;
/**
 * Prints version in all commands, except version commands.
 */
const printVersion = () => {
    const isVersionCommand = process.argv.at(-1) === '--version' || process.argv.at(-1) === 'version';
    if (!isVersionCommand) {
        process.stdout.write(chalk_1.default.dim(`datadog-ci v${exports.cliVersion}\n`));
    }
};
exports.printVersion = printVersion;
//# sourceMappingURL=version.js.map